import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';


@NgModule({
  imports: [AuthModule.forRoot({
    config: {
          authority: environment.authority,
          redirectUrl: environment.redirectUrl,
          authWellknownEndpointUrl: environment.authWellknownEndpointUrl,
          checkRedirectUrlWhenCheckingIfIsCallback: false,
          triggerAuthorizationResultEvent: true,
          unauthorizedRoute: '/unauthorized',
          forbiddenRoute: '/forbidden',
          postLogoutRedirectUri: window.location.origin,
          clientId: environment.clientId,
          scope: environment.scope,
          responseType: environment.responseType,
          silentRenew: false,
          useRefreshToken: false,
          renewTimeBeforeTokenExpiresInSeconds: 30,
          maxIdTokenIatOffsetAllowedInSeconds: 180
      }
  })],
exports: [AuthModule],
})
export class AuthConfigModule { }
